<template>
  <div class="app-container">
    <nav-bar />
    <div class="main-content">
      <router-view v-if="showRouterView"></router-view>
      <div class="debug-info" v-if="showDebug">
        当前路由: {{ $route.path }} | 渲染状态: {{ showRouterView ? '显示' : '隐藏' }}
      </div>
    </div>
    <app-footer />
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'
import AppFooter from './components/AppFooter.vue'

export default {
  name: 'App',
  components: {
    NavBar,
    AppFooter
  },
  data() {
    return {
      showDebug: process.env.NODE_ENV !== 'production',
      showRouterView: true  // 控制router-view的显示
    }
  },
  watch: {
    $route(to, from) {
      console.log('[App.vue] 检测到路由变化:', from.path, '->', to.path);
      
      // 临时隐藏然后显示router-view来强制重新渲染
      this.showRouterView = false;
      console.log('[App.vue] 临时隐藏router-view');
      
      setTimeout(() => {
        this.showRouterView = true;
        console.log('[App.vue] 恢复显示router-view');
        this.$forceUpdate();
        console.log('[App.vue] 强制更新完成');
      }, 10);
    }
  },
  mounted() {
    console.log('[App.vue] 组件已挂载');
    console.log('[App.vue] 当前路由:', this.$route.path);
    
    // 监听全局错误
    window.addEventListener('error', (event) => {
      console.error('[App.vue] 捕获到全局错误:', event.message);
    });
    
    // 添加路由变化完成事件监听
    this.$router.afterEach((to, from) => {
      console.log('[App.vue] 路由变化完成:', from.path, '->', to.path);
    });
  },
  methods: {
    logNavigationState() {
      console.log('[App.vue] 导航状态:', {
        currentRoute: this.$route.path,
        routerViewVisible: this.showRouterView
      });
    }
  }
}
</script>

<style>
body {
  margin: 0;
  font-family: "Helvetica", sans-serif;
  background: #111;
  color: white;
  scroll-behavior: smooth;
  overflow-x: hidden;
}

.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  padding-top: 60px; /* 为固定的导航栏留出空间 */
}

.debug-info {
  position: fixed;
  bottom: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.7);
  color: #e50914;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 12px;
  z-index: 9999;
}
</style> 